import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "m11.554 10.9.01-.009.011-.009L19.5 4.096v9.43a1.5 1.5 0 0 1-1.5 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-9.43l7.974 6.825.012.01.013.01c.428.322.95.495 1.485.494h.002a2.6 2.6 0 0 0 1.568-.535zm6.85-9.816L10 8.281 1.595 1.084q.198-.057.406-.059H18q.208.001.406.06z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }